import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getIsCategorySet = (state) => {
    return state.dataList !== null && Object.keys(state.dataList).length > 0;
};
export const getBaseCategory = (state) => {
    return state.dataList?.find((item) => item.name === "basic") || null;
};
export const getClassCategories = (state) => {
    return state.dataList?.filter((item) => item.name !== "basic") || null;
};
export const getCurrentClassCategory = (state) => {
    return state.currentClassCategory;
};
export const getSubcategoryDetails = (state) => {
    return state.subCategory?.details;
};
export const getSubcategoryQuestions = (state) => {
    return state.subCategory?.questions;
};
export const getYoutubeLink = (state) => {
    return state.youtubeLink;
};
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getIsCategorySet,
    getBaseCategory,
    getClassCategories,
    getSubcategoryDetails,
    getSubcategoryQuestions,
    getCurrentClassCategory,
    getYoutubeLink,
};
